import { api } from "./api";
import { DepartamentoResponse } from "../types/puesto";

export const DepartamentoService = {
    //Obtener todos los departamentos
    getAll: (activo: boolean) => {
        return api.get(`/departamentos/${activo ? 1 : 0}`);
    },

    //Obtener todos los departamentos con el usado
    getConUsado: (id: number) => {
        if (!Number.isInteger(id) || id < 0) {
            throw new Error("ID debe ser un número positivo");
        }
        return api.get(`/departamentos/usado/${id}`);
    },

    //Obtener por id
    getById: (id: number) => {
        if (!Number.isInteger(id) || id < 0) {
            throw new Error("ID debe ser un número positivo");
        }
        return api.get(`departamentos/${id}/individual`)
    },

    //Crear departamento
    create: (data: DepartamentoResponse) => {
        return api.post("departamentos", data);
    },

    //Actualizar departamento
    update: (id: number, data: DepartamentoResponse) => {
        if (!Number.isInteger(id) || id < 0) {
            throw new Error("ID debe ser un número positivo");
        }
        return api.put(`departamentos/${id}/actualizar`, data);
    },

    // Desactivar departamento
    desactivar: (id: number) => {
        return api.put(`/departamentos/${id}/desactivar`);
    },

    // Activar departamento
    activar: (id: number) => {
        return api.put(`/departamentos/${id}/activar`);
    },
}